import {AxiosInstance} from "axios";
import {OrganizationStripeAccount, StripeConnectOnboardingLink} from "@/stripe-connect/interfaces";

export default function (client: AxiosInstance) {
    return {
        /**
         * Get the connected account state of the current organization.
         *
         * @return The account state, or null when no account has been created yet.
         */
        async getAccount(): Promise<OrganizationStripeAccount | null> {
            return client.get('stripe/connect/account')
                .then(response => response.data.data);
        },

        /**
         * Create the connected account for the current organization, idempotent.
         */
        async createAccount(): Promise<OrganizationStripeAccount> {
            return client.post('stripe/connect/account')
                .then(response => response.data.data);
        },

        /**
         * Create a stripe hosted onboarding link for the connected account.
         */
        async createOnboardingLink(): Promise<StripeConnectOnboardingLink> {
            return client.post('stripe/connect/account/onboarding-link')
                .then(response => response.data);
        }
    };
}
